
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(253|287|336|757|889)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
